module.exports = __webpack_public_path__ + "img/tuchu.8bac5bec.png";